var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeflixCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 199,
    viewBox: "0 0 358 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 358,
    height: 199,
    rx: 8,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3061_17508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.227 124.702C104.248 125.227 101.217 125.385 98.0818 125.804L88.5181 97.6699V127.012C85.5395 127.327 82.822 127.747 80 128.167V74.4166H87.9436L98.8133 104.914V74.4166H107.227V124.702ZM123.689 94.1005C126.929 94.1005 131.894 93.943 134.872 93.943V102.341C131.162 102.341 126.824 102.341 123.689 102.499V114.992C128.601 114.677 133.514 114.256 138.478 114.099V122.182L115.327 124.02V74.4166H138.478V82.8151H123.689V94.1005ZM169.572 82.8153H160.897V121.448C158.075 121.448 155.253 121.448 152.536 121.553V82.8153H143.861V74.4166H169.573L169.572 82.8153ZM183.16 93.5232H194.605V101.921H183.16V120.976H174.954V74.4166H198.315V82.8151H183.16V93.5232ZM211.902 113.627C216.658 113.731 221.466 114.1 226.117 114.362V122.655C218.644 122.182 211.171 121.711 203.541 121.553V74.4166H211.902V113.627ZM233.172 123.233C235.837 123.39 238.659 123.548 241.376 123.862V74.4166H233.172V123.233ZM278.011 74.4166L267.402 99.9794L278.011 128.167C274.875 127.747 271.739 127.169 268.604 126.644L262.594 111.108L256.48 125.385C253.449 124.86 250.522 124.702 247.492 124.282L258.257 99.6642L248.536 74.4166H257.525L263.012 88.5365L268.865 74.4166H278.011V74.4166Z",
    fill: "#D81F26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3061_17508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 86,
    fill: "white",
    transform: "translate(80 56.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeflixCard);
export default __webpack_public_path__ + "static/media/NeflixCard.cf4b34ff617f4ddef985b35ca172fb7e.svg";
export { ForwardRef as ReactComponent };